import { makeStyles } from '@material-ui/core'

export default makeStyles((theme) => ({
  root: {
    background: theme.palette.extras.slate,
    boxShadow: theme.shadows[0],
    borderTop: '0px solid black',
    borderRadius: theme.spacing(0.5),
    margin: theme.spacing(1, 0),
  },
  heading: {
    fontFamily: 'Roboto Condensed',
    fontSize: theme.typography.h6.fontSize,
    fontWeight: theme.typography.fontWeightMedium,
    color: theme.palette.text.white,
  },
}))
